import { useEffect, useState } from 'react';
import Select from 'react-select';
import { Filters, IAttorneyResponse, Sort } from '../../lib/types';
import { attorneyFiltersAtom, customersSortAtom } from '../../recoil/customers-sort-filter';
import QuickFilter from '../quick-filter/quick-filter';
import SortButton, { ISortButtonProps } from '../sort-button/sort-button';
import './sort-filter.scss';
import { useRecoilState } from 'recoil';
import api from '../../lib/api';
import FilterPill from '../filter-pill/filter-pill';

export interface ISortFilterProps {
   disabled: boolean;
   affiliateId?: number;
}

export default function SortFilter(props: ISortFilterProps): JSX.Element {
   const sortButtonProps: ISortButtonProps = {
      disabled: props.disabled,
      sortAtom: customersSortAtom,
      sorts: [
         { sort: Sort.firstName, ascendingDescending: true },
         { sort: Sort.lastName, ascendingDescending: true },
         { sort: Sort.email, ascendingDescending: false },
         { sort: Sort.mostRecentViolation, ascendingDescending: false },
         { sort: Sort.numberOfViolations, ascendingDescending: true },
         { sort: Sort.nextCalibrationDate, ascendingDescending: true },
         { sort: Sort.leaseDate, ascendingDescending: true },
         { sort: Sort.removalDate, ascendingDescending: true },
      ],
   };

   // Recoil state for selected attorneys
   const [attorneyFilters, setAttorneyFilters] = useRecoilState(attorneyFiltersAtom);

   // Local state for dropdown options
   const [attorneyOptions, setAttorneyOptions] = useState<{ value: string; label: string }[]>([]);
   const [loading, setLoading] = useState(false);

   useEffect(() => {
      async function fetchAttorneys() {
         if (!props.affiliateId) return;
         setLoading(true);
         try {
            const res: IAttorneyResponse | null = await api.getAffiliateList(props.affiliateId);
            if (res?.attorneyNames) {
               setAttorneyOptions(
               res.attorneyNames.map((name) => ({
                  value: name,
                  label: name,
               }))
               );
            }
         } catch (error) {
            console.error('Error fetching attorney list:', error);
         } finally {
            setLoading(false);
         }
      }

      fetchAttorneys();
   }, [props.affiliateId]);

   const handleAttorneyChange = (selected: any) => {
      const values = selected?.map((option: any) => option.value) || [];
      setAttorneyFilters(values);
   };
  
   const selectedOptions = attorneyOptions.filter((option) =>
      attorneyFilters.includes(option.value)
   );

   return (
      <div className="sort-filter">
         <div className="sort-filter-wrapper">
            <QuickFilter disabled={props.disabled} text={Filters.all} />
            <QuickFilter
               disabled={props.disabled}
               text={Filters.recentViolations}
            />
            <QuickFilter disabled={props.disabled} text={Filters.newClients} />
            <QuickFilter disabled={props.disabled} text={Filters.alerts} />
            <QuickFilter
               disabled={props.disabled}
               text={Filters.overdueCalibrations}
            />

            <div className="sort-attorney-wrapper">
               <div className="attorney-multi-select">
                  <Select
                     isMulti
                     options={attorneyOptions}
                     value={selectedOptions}
                     onChange={handleAttorneyChange}
                     placeholder={loading ? 'Loading attorneys...' : 'Filter by Attorney'}
                     isDisabled={props.disabled || loading}
                     closeMenuOnSelect={false}
                     hideSelectedOptions={false}
                     styles={{
                        multiValue: (base, state) => {
                           // hide all but first selected item
                           const index = selectedOptions.findIndex(opt => opt.value === state.data.value);
                           return index === 0 ? base : { ...base, display: 'none' };
                        },
                        multiValueLabel: (base, state) => {
                           const index = selectedOptions.findIndex(opt => opt.value === state.data.value);
                           if (index === 0 && selectedOptions.length > 1) {
                              return {
                                 ...base,
                                 '::after': {
                                    content: `" +${selectedOptions.length - 1}"`,
                                    marginLeft: '4px',
                                    color: '#555',
                                 },
                              };
                           }
                           return base;
                        },
                     }}
                  />
               </div>

               <SortButton
                  disabled={sortButtonProps.disabled}
                  sortAtom={customersSortAtom}
                  sorts={sortButtonProps.sorts}
               />
            </div>
         </div>

         {/* Filter pills */}
         {/* {attorneyFilters.length > 0 && (
            <div className="attorney-filter-pills">
               <div className="body-standard-semibold">Filters:</div>
               {attorneyFilters.map((attorney) => (
                  <FilterPill
                  key={attorney}
                  text={attorney}
                  currentFilters={attorneyFiltersAtom}
                  />
               ))}
            </div>
         )} */}

      </div>
   );
}
